import { parse, isWithinTimeFrame } from 'helpers/dates';
import NBXPayments from 'services/payments.service';
import NBXWithdrawals from 'services/withdrawals.service';
import dayjs from 'dayjs';
import { ErrorToHandle } from 'helpers/customErrors';

const depositToReportFormat = (deposit, asset) => {
  return {
    id: deposit.id,
    created: parse(deposit.createdAt),
    type: 'Deposit',
    inAmount: deposit.amount,
    inCurrency: asset,
    outAmount: undefined,
    outCurrency: undefined,
    fee: undefined,
    feeCurrency: undefined,
    notes: undefined,
    market: 'NBX'
  };
};

const withdrawToReportFormat = (withdraw, asset) => {
  return {
    id: withdraw.id,
    created: parse(withdraw.createdAt),
    type: 'Withdraw',
    inAmount: undefined,
    inCurrency: undefined,
    outAmount: withdraw.totalAmount,
    outCurrency: asset,
    fee: withdraw.fees,
    feeCurrency: asset,
    notes: undefined,
    market: 'NBX'
  };
};

export const fetchDepositsWithdraws = async (startTimeDjs, endTimeDjs, assetsData) => {
  const assets = Object.keys(assetsData).filter(asset => !['TEST1', 'TEST2'].includes(asset));

  // [[asset1DepsPromise, asset1WithdrawsPromise], [asset2DepsPromise, asset2WithdrawsPromise], ...]
  const allPromises = assets.map(asset => {
    const depositsPromise = window.REQ_RATE_LIMITER.rateLimitedRequest(() =>
      NBXPayments.getDeposits({ asset })
    )
      .then(depositsResp => {
        if (depositsResp.length === 0) return null;

        return depositsResp
          .filter(
            d =>
              isWithinTimeFrame(startTimeDjs, endTimeDjs, dayjs(d.createdAt)) &&
              d.status.includes('COMPLETED')
          )
          .map(d => depositToReportFormat(d, asset));
      })
      .catch(e => {
        if (e instanceof ErrorToHandle && e.props.status_404) {
          console.warn(`404 for ${asset} deposits`);
          return;
        }
        throw e;
      });

    const withdrawsPromise = window.REQ_RATE_LIMITER.rateLimitedRequest(() =>
      NBXWithdrawals.getWithdrawals({ asset })
    )
      .then(withdrawsResp => {
        if (withdrawsResp.length === 0) return null;

        return withdrawsResp
          .filter(
            w =>
              isWithinTimeFrame(startTimeDjs, endTimeDjs, dayjs(w.createdAt)) &&
              w.status.includes('COMPLETED')
          )
          .map(w => withdrawToReportFormat(w, asset));
      })
      .catch(e => {
        if (e instanceof ErrorToHandle && e.props.status_404) {
          console.warn(`404 for ${asset} withdraws`);
          return;
        }
        throw e;
      });

    return [depositsPromise, withdrawsPromise];
  });

  // returns [asset1ReportFormat[], asset2ReportFormat[], ...]
  const allPromisesRes = await Promise.all(allPromises.flat());

  // returns [reportFormat, reportFormat, reportFormat, ...]
  const flatRes = allPromisesRes.flat().filter(res => {
    const isNotNullOrUndefined = res;
    return isNotNullOrUndefined;
  });
  return flatRes;
};
